<div id="onboarding-welcome-screen" class="custom-splash-screen empty-background">

  <div id="guide-step1" class="guide-container project">
    <div class="arrow arrow-up"></div>
    <div class="content-header">
      Create Memo
    </div>
    <div class="contents">
      <p>
        To get started, click the Create Memo button
        where you'll be taken through a short wizard to provide the settings for your new memo.
      </p>
      <p>
        Memos that have been added will be displayed on this screen which you can view or download.
        You'll also find various other options for your memos, including an Attach to Task option where you can share
        your memo with your contacts list by email.
      </p>
    </div>
    <div class="footer flex flex-row justify-start items-start">
      <button (click)="orbitaxPlatformOnboardingNext()" class="guide-action-btn"><i class="fal fa-plus"></i> Create Memo
      </button>
    </div>
  </div>
</div>
